import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import useGetAllHalaman from 'data/useGetAllHalaman'
import ComingSoon from 'views/ComingSoon/ComingSoon'
import { Spin } from 'antd'
import styles from './pages.module.scss'
const Editor = dynamic(() => import('@nexys/components/TextQuill/TextQuill'), {
  ssr: false,
})

function Pages() {
  const route = useRouter()
  const { page } = route.query
  const { data, isLoading, isFetching, length } = useGetAllHalaman(
    0,
    1,
    [
      {
        id: `tittle`,
        value: `${String(page)?.split('-')?.join(' ')}`,
      },
    ],
    {},
    {keepPreviousData: true, enabled: !!page}
  )

  return (
    <div
      style={{ height: (isLoading || isFetching) && '100vh' }}
      className={(isLoading || isFetching || !length) ? "flex justify-center items-center" : "flex mt-28 px-28" }
    >
      {
        (isLoading || isFetching) ? <Spin size="large" /> :
        !length ? <ComingSoon /> :
        <div className="w-full">
          <span className={styles.title}>{data?.[0]?.tittle}</span>
          {/* @ts-ignore */}
          <Editor
            className="pages-editor"
            theme="bubble"
            value={data?.[0]?.description}
            readOnly
          />
        </div>
      }
    </div>
  )
}

export default Pages
